// FC246/#1284: legacy intake linkage prerequisite is not an eBay API error.
// Keep the existing server status unchanged for safe approval compatibility.
export const isLegacyListingRequired = (projection) =>
  projection?.status === "missing_linked_listing";

export const isLegacyApprovalReady = (status) =>
  status === "ready_to_update" || status === "ready_to_relist";

export const legacyListingRequiredMessage = (projection) =>
  projection?.message ||
  "No linked listing. Link the exact existing listing or create an internal draft and review it before refreshing again. Approval is blocked.";

export const isHistoricalListingPrerequisite = (entry) =>
  entry?.error_type === "missing_linked_listing" &&
  ["ebay_refresh_preview", "ebay_apply_precheck"].includes(entry?.operation);

export const partitionLegacyEbayErrors = (entries = []) => ({
  errors: entries.filter((entry) => !isHistoricalListingPrerequisite(entry)),
  priorPrerequisites: entries.filter(isHistoricalListingPrerequisite),
});
